import Vue from 'vue'
export default new Vue({
  name: 'eventBus',
})



// WEBPACK FOOTER //
// ./src/eventBus.js